import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  OperationCharacteristicResponseDto
} from 'app/services/authentication/connection/interfaces/apiInterfaces';

export class GetOperationCharacteristicsCommand extends IRequestCommand<IGetOperationCharacteristicResponse, ErrorDetails, IGetOperationCharacteristicCommandParameters> {
    override _commandType: CommandRequestType = CommandRequestType.GET;
    override _commandUrl = 'operationCharacteristic';
    public override setParameters(parameters: IGetOperationCharacteristicCommandParameters) {}
}

export interface IGetOperationCharacteristicCommandParameters extends ICommandParameters {
    id?: number;
}

export interface IGetOperationCharacteristicResponse extends OperationCharacteristicResponseDto, ICommandResponse {}
